const GO_TEST_NAMES = {
  widget_filter: "widget_filter",
  calendar_reposition: "calendar_reposition",
  searchclips: "searchclips",
  syb_home_promo: "syb_home_promo",
  syb_promo: "syb_promo",
  calendar_widget_button: "calendar_widget_button",
  newtab: "newtab",
  contentfulOn: "contentfulOn",
  testOneOfferId: "testOneOfferId",
  content: "content",
  hls: "hls",
};

export { GO_TEST_NAMES };
